import {
  GoogleAuthProvider,
  getAuth,
  signInWithPopup,
  onAuthStateChanged,
} from "firebase/auth";
import firebaseApp from "./firebaseConfig";

class AuthService {
  constructor() {
    this.auth = getAuth(firebaseApp);
  }
  login() {
    const provider = new GoogleAuthProvider();
    return signInWithPopup(this.auth, provider);
  }
  logout() {
    this.auth.signOut();
  }
  onAuthChange(callback) {
    onAuthStateChanged(this.auth, (user) => callback(user));
  }
}

export default AuthService;
